<template>
<!--我的订单-->
  <div class="orders">
    <!-- <div v-show="$route.meta.navShow"> -->
      <div class="titleWrap">
        <p class="titleName">我的证书 > 全国物业行业项目经理职业资格证书</p>
      </div>
      <div class="content">
        <p class="title">物业管理项目经理岗位技能证书</p>
        <ul>
        	<li><span>姓      名</span> 王小东</li>
          <li><span>身份证号</span> 211002199005061977</li>
          <li><span>颁证机构</span> 中国物业管理协会</li>
          <li><span>证书名称</span> <p>物业管理项目经理岗位技能啊啊啊证书</p></li>
          <li><span>证书编号</span> GD201306120118</li>
          <li><span>颁证日期</span> 2019年10月20日</li>
          <li><span>证书有效期</span> 2019年10月20日</li>
        </ul>
      </div>
      <p>
        <router-link to="/">学分认定</router-link>
        <router-link to="/" class="save" style="display: none;">
        <img src="../../assets/download.png" alt="" width="22">保存相册</router-link>
      </p>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .titleWrap {
    height: 40px;
    font-size: 18px;
    padding-bottom: 20px;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 20px;
    color: #083C68;
    .titleName {
      float: left;
      line-height: 24px;
      padding-bottom: 13px;
    }
  }
  .content{
   background: url('../../assets/zhengshubg.png') no-repeat;
   width: 490px;
   height: 626px;
   margin:50px auto;
    padding-top: 50px;
   .title{
      font-size: 30px;
      color: #333;
      width: 300px;
      margin:50px auto;
      text-align: center;
      width: 240px;
      font-weight: 700;
   }
   li{
      font-size: 17px;
      color: #666;
      padding:0 70px;
      margin-bottom: 20px;
      span{
        color: #000;
        display: inline-block;
        width: 100px;
      }
      p{
        width: 240px;
        vertical-align: top;
        display: inline-block;
      }
   }
  }
  a{
    color: #fff ;
    font-size: 16px;
    background-color: #957960;
    display: block;
    width: 220px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 5px;
    margin: auto;
    img{
      vertical-align: middle;
      margin-right: 10px;
    }
  }
.save{
  border-radius: 50px;
}



</style>
<script type="text/ecmascript-6">
  import centers from '../template/center'
    export default {
        name: 'orderdetail',
        props: {},
        data() {
            return {


            };
        },
        methods: {

        },
        created() {

        },
        components: {
          centers
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/center/zhengshurending.vue